import Api from '@sendsprint/api-types';

export const getCurrencySymbol = (country: Api.Model.CountryInitials | string | undefined) => {
  let currency = '';

  switch (country) {
    case Api.Model.CountryInitials.Canada:
      currency = 'CAD';
      break;
    case Api.Model.CountryInitials.Ghana:
      currency = 'GHS';
      break;
    case Api.Model.CountryInitials.Kenya:
      currency = 'KES';
      break;
    case Api.Model.CountryInitials.Nigeria:
      currency = 'USD';
      break;
    case Api.Model.CountryInitials.NigeriaNig:
      currency = 'NGN';
      break;
    case Api.Model.CountryInitials.SouthAfrica:
      currency = 'ZAR';
      break;
    case Api.Model.CountryInitials.UnitedKingdom:
      currency = 'GBP';
      break;
    case Api.Model.CountryInitials.UnitedStates:
      currency = 'USD';
      break;
    default:
      currency = '';
      break;
  }

  return currency;
};

export const getCurrencySymbol2 = (country: Api.Model.CountryInitials | string | undefined) => {
  let currency = '';

  switch (country) {
    case Api.Model.CountryInitials.Canada:
      currency = 'CAD';
      break;
    case Api.Model.CountryInitials.Ghana:
      currency = 'GHS';
      break;
    case Api.Model.CountryInitials.Kenya:
      currency = 'KES';
      break;
    case Api.Model.CountryInitials.Nigeria:
    case Api.Model.CountryInitials.NigeriaNig:
      currency = 'NGN';
      break;
    case Api.Model.CountryInitials.SouthAfrica:
      currency = 'ZAR';
      break;
    case Api.Model.CountryInitials.UnitedKingdom:
      currency = 'GBP';
      break;
    case Api.Model.CountryInitials.UnitedStates:
      currency = 'USD';
      break;
    default:
      currency = '';
      break;
  }

  return currency;
};

export const getSenderCountryFromCurrency = (currency: string | undefined) => {
  switch (currency) {
    case 'USD':
      return Api.Model.CountryInitials.UnitedStates;

    case 'GBP':
      return Api.Model.CountryInitials.UnitedKingdom;

    case 'CAD':
      return Api.Model.CountryInitials.Canada;

    default:
      return '';
  }
};

export const getReceiverCountryFromCurrency = (currency: string | undefined) => {
  switch (currency) {
    case 'USD':
      return Api.Model.CountryInitials.Nigeria;

    case 'NGN':
      return Api.Model.CountryInitials.NigeriaNig;

    case 'ZAR':
      return Api.Model.CountryInitials.SouthAfrica;

    case 'KES':
      return Api.Model.CountryInitials.Kenya;

    case 'GHS':
      return Api.Model.CountryInitials.Ghana;

    default:
      return '';
  }
};
